<div class="flex flex-col flex-auto min-w-0">

    <!-- Header -->
    <div
        class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <!-- Breadcrumbs -->
            <!-- <div class="flex flex-wrap items-center font-medium">
                <div>
                    <a class="whitespace-nowrap text-primary-500">Contact us</a>
                </div>
                <div class="flex items-center ml-1 whitespace-nowrap">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                    <a class="ml-1 text-primary-500">Form</a>
                </div>
            </div> -->
            <!-- Title -->
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Contact us
                </h2>
            </div>
        </div>
    </div>

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">

        <div class="max-w-3xl">

            <div class="prose prose-sm max-w-3xl">
                <p>
                    For quotations please find the talent          <a
                    [routerLink]="'/s'"
                    rel="noreferrer"
                    target="_blank">here
                </a> and fill up their quotation form directly.
                </p>
            </div>


            <div class="prose prose-sm max-w-3xl">
                <h2 class="mt-12"></h2>
                <p>
                    Fill up the form and we will be happy to assist you. Or you can also reach us by phone <a href="tel:+1 (647) 390-5455">+1 (647) 390-5455 </a>
                </p>
                <p>
                    Our office is located at 2455 Cawthra RD Unit 20, Mississauga, Ontario, L5A 3P1
                </p>
            </div>

            <form class="flex flex-col mt-4 px-8 pt-10 bg-card shadow rounded overflow-hidden"  [formGroup]="contactUsForm">
                <p class="text-lg font-medium">Contact Us Form</p>
                <p class="text-secondary mb-6">
                    <!-- Fill up the form and we will be happy to assist you. -->
                </p>
                <div class="flex">
                    <mat-form-field class="flex-auto">
                        <input matInput  [formControlName]="'name'" [placeholder]="'Name'">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user'"></mat-icon>
                    </mat-form-field>
                </div>
                <div class="flex">
                    <mat-form-field class="flex-auto">
                        <input matInput  [formControlName]="'email'"  [placeholder]="'Email Address'">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:mail'"></mat-icon>
                        <mat-error *ngIf="email.touched && email.hasError('email')">
                            Must be a valid email.
                        </mat-error>
                        <mat-error *ngIf="email.touched && email.hasError('required')">
                            Email is required.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="flex">
                    <mat-form-field class="flex-auto">
                        <input matInput  [formControlName]="'phonenumber'"  [placeholder]="'Phone Number'">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:phone'"></mat-icon>
                    </mat-form-field>
                </div>
                <div class="flex flex-col gt-xs:flex-row">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select  [formControlName]="'subject'"  [placeholder]="'Subject'" #subject>
                            <mat-option value="project">Existing project</mat-option>
                            <mat-option value="new-project">New project</mat-option>
                            <mat-option value="other">Other</mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:question-mark-circle'">
                        </mat-icon>
                    </mat-form-field>
                    <!-- <div > -->
                        <mat-form-field class="flex-auto gt-xs:pl-3" [class.cdk-visually-hidden]="hideProjectnumber" >
                            <input [formControlName]="'projectnumber'"  matInput [placeholder]="'Project Number'">
                            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:hashtag'"></mat-icon>
                            <mat-error *ngIf="projectnumber.touched && projectnumber.hasError('required')">
                                Project number is required.
                            </mat-error>
                        </mat-form-field>
                    <!-- </div> -->

                </div>

                <div class="flex">
                    <mat-form-field class="fuse-mat-textarea flex-auto">
                        <textarea  [formControlName]="'message'"  matInput [placeholder]="'Project info'"
                            [rows]="10"></textarea>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:menu-alt-2'">
                        </mat-icon>
                        <mat-error *ngIf="message.touched && message.hasError('required')">
                            Project info is required.
                        </mat-error>
                        <mat-error *ngIf="message.touched && message.hasError('maxlength')">
                            Max 3000 characters.
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="flex items-center justify-end border-t -mx-8 mt-8 px-8 py-5 bg-gray-50 dark:bg-gray-700">
                    <button mat-button>
                        Cancel
                    </button>
                    <button class="px-6 ml-3" mat-flat-button [color]="'primary'" type="submit" [disabled]="submitted"
                    (click)="submit()" >
                        Submit
                    </button>
                </div>
            </form>



        </div>
    </div>
</div>